/* @flow */
import Backbone from 'backbone-collection';
import sync from './BackboneSync';

export default class Collection extends Backbone.Collection {
  add(models: Object | Array<Object>, options: Object = {}) {
    // Make add() use `merge` by default
    return super.add(models, Object.assign({ merge: true }, options));
  }

  fetch(options: Object = {}): Promise<this> {
    return new Promise((resolve, reject) => {
      options.success = resolve;
      options.error = (model, response) => {
        reject(response);
      };
      super.fetch(options);
    });
  }

  sync() {
    return sync.apply(this, arguments);
  }

  jasmineToString(): string {
    return '[' + this.length + ' ' + this.model.name + 's]';
  }

  static fetch(options = {}): Promise<this> {
    return new this().fetch(options);
  }

  static fromJSON(models = []): this {
    return new this(models, { parse: true });
  }
}



// WEBPACK FOOTER //
// ./src/lib/Collection.js